module.exports = __webpack_public_path__ + "img/no.0b74d901.svg";